(() => {
  /* BEZELOR cart drawer v2 helpers (styles in bezelor-cart-v2.css):
     item count as a gold pill, tidy option chips, payment icons moved out of the checkout bar,
     a header shadow once the cart scrolls, and the cards' entrance when the cart opens.
     Re-applies after the theme redraws the cart. */
  if (window.__bzCartV2) return;
  window.__bzCartV2 = true;

  const enhance = () => {
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer && drawer.querySelector('.drawer__inner');
    if (!inner) return;

    const heading = inner.querySelector('.drawer__heading');
    if (heading && !heading.querySelector('.bz-cart-count')) {
      const match = heading.textContent.trim().match(/^(.*?)\s*\((\d+)\)$/);
      if (match) {
        heading.textContent = match[1];
        const pill = document.createElement('span');
        pill.className = 'bz-cart-count';
        pill.textContent = match[2];
        pill.setAttribute('aria-label', match[2] + (match[2] === '1' ? ' item' : ' items'));
        heading.append(pill);
      }
    }

    inner.querySelectorAll('.cart-item dl dd').forEach((dd) => {
      if (/,\s*$/.test(dd.textContent)) dd.textContent = dd.textContent.replace(/,\s*$/, '');
    });

    const pay = inner.querySelector('.drawer__footer .bz-cart-pay');
    const security = inner.querySelector(':scope > .bezelor-cart-security');
    if (pay && security) security.after(pay);

    if (!inner.dataset.bzCartV2) {
      inner.dataset.bzCartV2 = 'true';
      inner.addEventListener('scroll', () => inner.classList.toggle('bz-scrolled', inner.scrollTop > 4), { passive: true });
    }
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhance();
    });
  };

  const intro = (drawer) => {
    const inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    inner.scrollTop = 0;
    inner.classList.remove('bz-scrolled', 'bz-cart-intro');
    void inner.offsetWidth;
    inner.classList.add('bz-cart-intro');
    clearTimeout(inner.bzIntroTimer);
    inner.bzIntroTimer = setTimeout(() => inner.classList.remove('bz-cart-intro'), 1100);
  };

  const start = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    enhance();
    new MutationObserver(queue).observe(drawer, { childList: true, subtree: true });
    let wasOpen = drawer.classList.contains('active');
    new MutationObserver(() => {
      const open = drawer.classList.contains('active');
      if (open && !wasOpen) {
        enhance();
        intro(drawer);
      }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
